import type { Lang } from './i18n';

/**
 * Random display name = adjective + noun, in the requested language. Used to give
 * anonymous players a friendly handle without a sign-up; persisted by the caller.
 */
const WORDS: Record<Lang, { adj: string[]; noun: string[]; join: string }> = {
  en: {
    join: ' ',
    adj: ['Swift', 'Lucky', 'Silent', 'Brave', 'Sharp', 'Cool', 'Mighty', 'Clever', 'Sly', 'Bold',
      'Calm', 'Wild', 'Royal', 'Iron', 'Golden', 'Crimson', 'Shadow', 'Rapid', 'Lone', 'Smooth',
      'Steady', 'Fierce', 'Cosmic', 'Hidden', 'Electric', 'Phantom', 'Quiet', 'Quick'],
    noun: ['Cue', 'Shark', 'Tiger', 'Falcon', 'Hustler', 'Striker', 'Panther', 'Comet', 'Cobra', 'Wolf',
      'Eagle', 'Hawk', 'Rocket', 'Spinner', 'Banker', 'Maverick', 'Phantom', 'Bishop', 'Ace', 'Bullet',
      'Drifter', 'Pocket', 'Carom', 'Bouncer', 'Dragon', 'Fox', 'Raven'],
  },
  ko: {
    join: ' ',
    adj: ['빠른', '행운의', '조용한', '용감한', '날카로운', '멋진', '강력한', '영리한', '대담한', '차분한',
      '거친', '황금', '그림자', '외로운', '신속한', '무서운', '전설의', '은밀한', '화려한', '번개'],
    noun: ['큐', '상어', '호랑이', '매', '선수', '표범', '혜성', '늑대', '독수리', '로켓',
      '고수', '도사', '달인', '황제', '강자', '신동', '마술사', '사냥꾼', '검객', '여우'],
  },
};

const pick = <T>(a: T[]): T => a[Math.floor(Math.random() * a.length)];

/** A fresh "Adjective Noun" handle in the given language (e.g. "Swift Shark" / "빠른 상어"). */
export function randomDisplayName(lang: Lang): string {
  const w = WORDS[lang] ?? WORDS.en;
  return pick(w.adj) + w.join + pick(w.noun);
}
